<template>
  <teleport to="body">
    <div id="footer" class="
        bg-[#1A1A1A]
        z-[1]
        w-full
        transition-all
        px-[3vw]

        min-h-[470px]
        text-white
        grid grid-cols-12
        pb-[7vh] pt-[10vh] 
      ">
      <div class="lg:col-span-4 col-span-12 pb-[30px]  relative">
        <img src="/static/images/logo.png" alt="menu-logo" class="h-[130px] w-[130px]" />
        <div class="text-xl font-bold mt-2">{{ content.ismailKhayatArtGallery }}</div>

        <div class="text-sm mt-2">
          {{ content.allRightReserved }} © {{ new Date().getFullYear() }}
        </div>
        <div class="text-sm mt-2">
          {{ content.websiteBy }}
          <a href="https://blackace.tech" class="font-bold">Black Ace </a>
        </div>
        <div class="flex items-center absolute bottom-0 cursor-pointer group " @click="scrollToTop">
          <div class="
              h-8
              w-8
              bg-white
              rounded-full
              flex
              items-center
              justify-center
            ">
            <i class="fa fa-arrow-up text-black text-lg group-hover:mb-2 transition-all duration-200"></i>
          </div>
          <div class="text-base px-4">{{ content.backToTop }}</div>
        </div>
      </div>
      <div class="col-span-8 hidden lg:grid grid-cols-12">
        <div class="col-span-3">
          <div class="font-bold mb-8">{{ content.about }}</div>
          <router-link class="flex items-center group" @click="menuOpened = false" to="/biography">
            <div class="mb-2">{{ content.biography }}</div>
            <i
              class="fa fa-chevron-right mb-2  rtl:group-hover:mr-2 transition-all duration-200 opacity-0 group-hover:opacity-100 text-xs ltr:group-hover:ml-2 rtl:rotate-180"></i>
          </router-link>
          <router-link class="flex items-center group" @click="menuOpened = false" to="/personalphotos">
            <div class="mb-2">{{ content.photoGallery }}</div>
            <i
              class="fa fa-chevron-right mb-2  rtl:group-hover:mr-2 transition-all duration-200 opacity-0 group-hover:opacity-100 text-xs ltr:group-hover:ml-2 rtl:rotate-180"></i>
          </router-link>
        </div>
        <div class="col-span-3">
          <div class="font-bold mb-8">{{ content.artWorks }}</div>
          <router-link class="flex items-center group" @click="menuOpened = false" to="/works?type=allArtWorks">
            <div class="mb-2">{{ content.collections }}</div>
            <i
              class="fa fa-chevron-right mb-2  rtl:group-hover:mr-2 transition-all duration-200 opacity-0 group-hover:opacity-100 text-xs ltr:group-hover:ml-2 rtl:rotate-180"></i>
          </router-link>
          <router-link class="flex items-center group" @click="menuOpened = false" to="/works?type=paintings">
            <div class="mb-2">{{ content.paintings }}</div>
            <i
              class="fa fa-chevron-right mb-2  rtl:group-hover:mr-2 transition-all duration-200 opacity-0 group-hover:opacity-100 text-xs ltr:group-hover:ml-2 rtl:rotate-180"></i>
          </router-link>
          <router-link class="flex items-center group" @click="menuOpened = false" to="/works?type=drawings">
            <div class="mb-2">{{ content.drawings }}</div>
            <i
              class="fa fa-chevron-right mb-2  rtl:group-hover:mr-2 transition-all duration-200 opacity-0 group-hover:opacity-100 text-xs ltr:group-hover:ml-2 rtl:rotate-180"></i>
          </router-link>
          <router-link class="flex items-center group" @click="menuOpened = false" to="/works?type=stones">
            <div class="mb-2">{{ content.stones }}</div>
            <i
              class="fa fa-chevron-right mb-2  rtl:group-hover:mr-2 transition-all duration-200 opacity-0 group-hover:opacity-100 text-xs ltr:group-hover:ml-2 rtl:rotate-180"></i>
          </router-link>
          <router-link class="flex items-center group" @click="menuOpened = false" to="/works?type=unfinishedworks">
            <div class="mb-2">{{ content.unfinishedworks }}</div>
            <i
              class="fa fa-chevron-right mb-2  rtl:group-hover:mr-2 transition-all duration-200 opacity-0 group-hover:opacity-100 text-xs ltr:group-hover:ml-2 rtl:rotate-180"></i>
          </router-link>
        </div>
        <div class="col-span-3">
          <div class="font-bold mb-8">{{ content.mediaAndArchive }}</div>

          <router-link class="flex items-center group" @click="menuOpened = false" to="/archive?type=books">
            <div class="mb-2">{{ content.books }}</div>
            <i
              class="fa fa-chevron-right mb-2  rtl:group-hover:mr-2 transition-all duration-200 opacity-0 group-hover:opacity-100 text-xs ltr:group-hover:ml-2 rtl:rotate-180"></i>
          </router-link>
          <router-link class="flex items-center group" @click="menuOpened = false" to="/archive?type=writings">
            <div class="mb-2">{{ content.writings }}</div>
            <i
              class="fa fa-chevron-right mb-2  rtl:group-hover:mr-2 transition-all duration-200 opacity-0 group-hover:opacity-100 text-xs ltr:group-hover:ml-2 rtl:rotate-180"></i>
          </router-link>
          <router-link class="flex items-center group" @click="menuOpened = false" to="/videos">
            <div class="mb-2">{{ content.videos }}</div>
            <i
              class="fa fa-chevron-right mb-2  rtl:group-hover:mr-2 transition-all duration-200 opacity-0 group-hover:opacity-100 text-xs ltr:group-hover:ml-2 rtl:rotate-180"></i>
          </router-link>
        </div>
        <div class="col-span-3">
          <div class="font-bold mb-8">{{ content.legacy }}</div>

          <router-link class="flex items-center group" @click="menuOpened = false"
            to="/legacy?type=internationalacclaims">
            <div class="mb-2">{{ content.internationalacclaims }}</div>
            <i
              class="fa fa-chevron-right mb-2  rtl:group-hover:mr-2 transition-all duration-200 opacity-0 group-hover:opacity-100 text-xs ltr:group-hover:ml-2 rtl:rotate-180"></i>
          </router-link>
          <router-link class="flex items-center group" @click="menuOpened = false" to="/legacy?type=exhibitions">
            <div class="mb-2">{{ content.exhibitions }}</div>
            <i
              class="fa fa-chevron-right mb-2  rtl:group-hover:mr-2 transition-all duration-200 opacity-0 group-hover:opacity-100 text-xs ltr:group-hover:ml-2 rtl:rotate-180"></i>
          </router-link>
          <router-link class="flex items-center group" @click="menuOpened = false" to="/legacy?type=impactonart">
            <div class="mb-2">{{ content.impactonart }}</div>
            <i
              class="fa fa-chevron-right mb-2  rtl:group-hover:mr-2 transition-all duration-200 opacity-0 group-hover:opacity-100 text-xs ltr:group-hover:ml-2 rtl:rotate-180"></i>
          </router-link>
          <router-link class="flex items-center group" @click="menuOpened = false" to="/legacy?type=achievements">
            <div class="mb-2">{{ content.achievements }}</div>
            <i
              class="fa fa-chevron-right mb-2  rtl:group-hover:mr-2 transition-all duration-200 opacity-0 group-hover:opacity-100 text-xs ltr:group-hover:ml-2 rtl:rotate-180"></i>
          </router-link>
          <router-link class="flex items-center group" @click="menuOpened = false" to="/legacy?type=projects">
            <div class="mb-2">{{ content.projects }}</div>
            <i
              class="fa fa-chevron-right mb-2  rtl:group-hover:mr-2 transition-all duration-200 opacity-0 group-hover:opacity-100 text-xs ltr:group-hover:ml-2 rtl:rotate-180"></i>
          </router-link>
        </div>
      </div>
    </div>
  </teleport>
</template>
<script>
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);
export default {
  inject: ["content"],
  methods: {
    scrollToTop() {
      gsap.to(window, { duration: 2, scrollTo: { y: 0, x: 0 } });
    },
  },
};
</script>
